// Configuration centralisée de l'URL de base de l'API
// En dev local & réseau local (mobile) : utilise le proxy Vite "/api"
// Si VITE_API_URL pointe vers localhost mais qu'on accède depuis un mobile (IP LAN), on utilise "/api"
const rawBase: string | undefined = (import.meta as any).env?.VITE_API_URL;

const isMobileLanWithLocalhost = (): boolean => {
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';
    return !isLocalhost && Boolean(rawBase && (rawBase.includes('localhost') || rawBase.includes('127.0.0.1')));
  }
  return false;
};

const resolveApiBase = (): string => {
  if (isMobileLanWithLocalhost()) {
    return '/api';
  }
  return rawBase && rawBase.trim() ? `${rawBase.trim().replace(/\/+$/, '')}/api` : '/api';
};

export const API_BASE = resolveApiBase();

/**
 * Origine du serveur Backend (ex: 'https://api.zeyilo.com' ou 'http://localhost:3000' en proxy)
 * Utilisé pour Socket.IO et les médias stockés sur le backend.
 */
export const getBackendOrigin = (): string => {
  if (isMobileLanWithLocalhost()) {
    return window.location.origin;
  }
  if (rawBase && rawBase.trim()) {
    return rawBase.trim().replace(/\/+$/, '').replace(/\/api$/, '');
  }
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }
  return 'http://localhost:3000';
};

/**
 * Transforme une URL relative (ex: '/api/media/images/photo.jpg')
 * en URL absolue vers le backend si le frontend et le backend sont séparés.
 */
export const getMediaUrl = (url?: string | null): string => {
  if (!url) return '';
  if (
    url.startsWith('http://') ||
    url.startsWith('https://') ||
    url.startsWith('data:') ||
    url.startsWith('blob:')
  ) {
    return url;
  }
  const origin = getBackendOrigin();
  const cleanPath = url.startsWith('/') ? url : `/${url}`;
  const sanitizedPath = cleanPath.replace(/^\/api\/api\//, '/api/');

  if (typeof window !== 'undefined' && origin === window.location.origin) {
    return sanitizedPath;
  }
  return `${origin}${sanitizedPath}`;
};


